import { useState, useMemo } from "react";
import type { SelectOption } from "../types/types";

export const useMultiSelectSearch = (options: SelectOption[]) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions = useMemo(() => {
    if (!searchTerm) return options;
    return options.filter(
      option => option.label.toLowerCase().includes(searchTerm.toLowerCase()) && !option.isPlaceholder,
    );
  }, [options, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    filteredOptions,
  };
}; 